import { h } from 'preact';
import Section from 'components/bolt/section/section';
import Question from 'components/bolt/expandableTextList/question';
import s from 'components/bolt/expandableTextList/expandableTextList.sss';
import HTML from 'components/core/html/html';
import { joinClasses, sortObjectByOrder } from 'utils/utils';
import { onMarkdownClick } from 'utils/bolt';
import Store from 'store/store';

export default class ExpandableTextList extends Section {
	constructor(props) {
		super(props);
		this.changeActiveKey = this.changeActiveKey.bind(this);

		this.state = {
			activeKey: null
		};
	}

	componentDidMount() {
		super.componentDidMount();
	}

	getPageData() {
		return this.props.appData?.pages?.[this.props.id]?.data || {};
	}

	getTitle() {
		return this.getPageData().title;
	}
	getDescription() {
		return this.getPageData().description;
	}
	getQuestions() {
		return this.getPageData().questions;
	}

	onClick(e) {
		onMarkdownClick(e);
	}

	changeActiveKey(key) {
		const { activeKey } = this.state;
		if (key !== activeKey) {
			this.setState({ activeKey: key });
			Store.emit('TEXT_LIST_CLICK', key);
		} else {
			this.setState({ activeKey: null });
		}
	}

	renderTitle() {
		const content = this.getTitle();
		if (!content) return;
		return <HTML tag="h1" class={joinClasses(s.title, 'h3')} content={content} markdown inline key="title" />;
	}

	renderDescription() {
		const content = this.getDescription();
		if (!content) return;
		return <HTML tag="h2" class={joinClasses(s.description, 'xlarge')} content={content} markdown onClickCapture={this.onClick} key="description" />;
	}

	renderQuestions() {
		const questions = this.getQuestions();
		return (
			<div class={s.questions} key="questions">
				{sortObjectByOrder(questions, (data, key) => {
					const { type, question, answer } = data;

					if (type === 'separator') {
						return <div class={s.separator}>{question}</div>;
					}

					return (
						<Question
							key={key}
							question={!!question && <HTML markdown content={question} class={question} inline />}
							answer={answer}
							isOpen={this.state.activeKey === key}
							toggleActive={() => this.changeActiveKey(key)}
						/>
					);
				})}
			</div>
		);
	}

	render(props) {
		const isSection = !!props.appData?.pages[props.id]?.section;

		return (
			<div class={joinClasses(s.wrapper, isSection && s.section)} data-section={isSection && props.id}>
				{this.renderBgContent()}
				{this.renderTitle()}
				{this.renderDescription()}
				{this.renderQuestions()}
				{this.renderOverlayedContent()}
			</div>
		);
	}
}